import React from 'react';

const HeaderPlaceholder = () => (
    <div className="container-header-placeholder" id="container-header-placeholder"/>
);

export default HeaderPlaceholder;



// WEBPACK FOOTER //
// ./src/components/header/HeaderPlaceholder.jsx